import createSetSearchTypeVar from './setSarchType';
import { searchTypeVar } from '../reactiveVariables';

const setSearchType = createSetSearchTypeVar(searchTypeVar);

export default setSearchType;
